import { FC } from 'react';
import { HorizontalPaddingLayout } from '@/HorizontalPaddingLayout';
import { Divider } from '@/components/Divider';
import { AssetSectionAccordion } from './components/AssetSectionAccordion';
import { AssetType } from './components/AssetType';
import { AutoInvest } from './components/AutoInvest';
import { PendingTransactions } from './components/PendingTransactions';
import { AssetEfficiency, AssetsValue, SingleAssetTrend } from './components';

export const AssetSection: FC = () => {
  return (
    <div>
      <HorizontalPaddingLayout className="gap-y-6 py-4">
        <AssetsValue />
        <AssetSectionAccordion>
          <AssetType />
          <SingleAssetTrend />
        </AssetSectionAccordion>
      </HorizontalPaddingLayout>
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        <AssetEfficiency />
      </HorizontalPaddingLayout>
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        <PendingTransactions />
      </HorizontalPaddingLayout>
      <AutoInvest />
    </div>
  );
};
